// If browsed page is not found
export const ERROR_404_CLASSNAME = 'socna-printer-404-error';

// Buttons
export const PRINT_SUBMIT_ID = 'socna-printer-submit-button';
export const PRINT_RESET_ID = 'socna-printer-reset-button';

// Form fields
export const PRINT_STEP_ID = 'socna-printer-step';
export const PRINT_GROUPS_COUNT_ID = 'socna-printer-groups-count';
export const PRINT_GROUP_INDEX_ID = 'socna-printer-group-index';
export const PRINT_GROUP_ORIENTATION_ID = 'socna-printer-group-orientation';
export const PRINT_GROUP_PAPER_FORMAT_ID = 'socna-printer-group-paper-format';
export const PRINT_ADD_GROUP_HEADERS_ID = 'socna-printer-add-group-headers';
export const PRINT_ADD_GROUP_FOOTERS_ID = 'socna-printer-add-group-footers';
export const PRINT_SUPPORT_PAGE_COUNT_ID = 'socna-printer-support-page-count';
export const PRINT_ADD_PRINT_HEADERS_ID = 'socna-printer-add-print-headers';
export const PRINT_ADD_PRINT_FOOTERS_ID = 'socna-printer-add-print-footers';
export const PRINT_STYLE_ID_ID = 'socna-printer-style-id';
export const PRINT_STYLE_CODE_ID = 'socna-printer-style-code';
export const PRINT_FILE_CATEGORY_ID_ID = 'socna-printer-file-category-id';
export const PRINT_SECTION_TITLES_LIST_ID = 'socna-printer-section-titles-list';
export const PRINT_SECTION_DISPLAY_FIRST_PAGE_NUMBERS_ID =
  'socna-printer-section-display-first-page-numbers';
export const PRINT_TOTAL_DISPLAY_PAGE_COUNT_ID =
  'socna-printer-total-display-page-count';
export const PRINT_CODE_ID = 'socna-printer-code';
export const PRINT_TITLE_ID = 'socna-printer-title';
export const PRINT_NEED_PRINT_FEEDBACKS_ID =
  'socna-printer-need-print-feedbacks';
export const PRINT_PDF_PRINTS_INCREMENT_ID =
  'socna-printer-pdf-prints-increment';

// Content
export const PRINTER_BODY_ID = 'socna-printer-body';
export const PRINTER_FULLY_COMPILED_CLASSNAME = 'fully-compiled';

// Resolvers
export const RESOLVER_CONTENT_CLASSNAME = 'resolver-content';

// Fonts
export const PRINTER_FONT_FAMILY =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";

// Separator between chapter number and title
export const DISPLAY_PATH_TITLE_SEPARATOR = '■';

// Shared paths
export const PATH_SECTION_TEMPLATE_PRINTER = '/modeles/section/:id/imprimante';
export const PATH_SECTION_TEMPLATES_NEW_PRINTER =
  '/modeles/sections/nouveau/imprimante';
export const PATH_DOCUMENT_TEMPLATE_PRINTER =
  '/modeles/document/:id/imprimante';
export const PATH_DOCUMENT_TEMPLATES_NEW_PRINTER =
  '/modeles/documents/nouveau/imprimante';
export const PATH_MISSION_REPORT_PRINTER =
  '/dossiers/:folderId/missions/:missionId/rapports/:reportInfoId/imprimante';
export const PATH_MISSION_QUOTATION_PRINTER =
  '/dossiers/:folderId/missions/:missionId/devis/imprimante';
